import { Link } from "react-router";
import { useT } from "@client/i18n";

export function NotFoundPage() {
  const t = useT();
  return (
    <main className="mx-auto flex min-h-screen max-w-lg flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="font-display text-3xl text-ink-900 dark:text-ink-50">{t("notFound.title")}</h1>
      <p className="text-ink-600 dark:text-ink-400">{t("notFound.body")}</p>
      <Link to="/" className="text-accent-700 underline dark:text-accent-300">
        {t("notFound.home")}
      </Link>
    </main>
  );
}

export default NotFoundPage;
